import { Side } from "@cur8/api-client";

/**
 * Code duplication from DoctorUI, should probably move into package
 */

const SIDES: Side[] = ["front", "back"];

function isSide(value: unknown): value is Side {
  return SIDES.includes(value as Side);
}

export class PanoramaImageURI {
  type = "panorama";
  deviceId: string;
  recordingId: string;
  side: Side;
  cameraName: string;

  static fromString(uri: string) {
    const [type, deviceId, recordingId, side, cameraName] = uri
      .split(":")
      .map(decodeURIComponent);

    if (!isSide(side)) {
      throw new Error(`Invalid value for side: ${side}`);
    }

    if (type !== "panorama") {
      throw new Error("Not PanoramaImageURI");
    }

    return new PanoramaImageURI(deviceId, recordingId, side, cameraName);
  }

  constructor(
    deviceId: string,
    recordingId: string,
    side: Side,
    cameraName: string
  ) {
    this.type = "panorama";
    this.deviceId = deviceId;
    this.recordingId = recordingId;
    this.side = side;
    this.cameraName = cameraName;
  }

  toString(): string {
    return [
      "panorama",
      this.deviceId,
      this.recordingId,
      this.side,
      this.cameraName,
    ]
      .map(encodeURIComponent)
      .join(":");
  }
}
